var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Personal',{staticClass:"q-pa-md"}),_c('Contact',{staticClass:"q-pa-md"}),_c('Address',{staticClass:"q-pa-md"}),_c('Employment',{staticClass:"q-pa-md"}),_c('FATCA',{staticClass:"q-pa-md"}),_c('DeclarationCheckbox',{ref:"DCB",staticClass:"q-pa-md",on:{"Agreed":function($event){return _vm.AgreeOnDeclaration()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }